import React from 'react'
import { SvgIcon } from '@mui/material'

export function MicActiveIcon() {
  return (
    <SvgIcon
      viewBox="0 0 64 64"
      sx={{ color: 'error.main', width: '64px', height: '64px' }}
    >
      <g clipPath="url(#MicActiveIconUrl)">
        <path
          fill="#55A6FF"
          d="M32 37.334c4.427 0 8-3.574 8-8v-16c0-4.427-3.573-8-8-8a7.99 7.99 0 0 0-8 8v16c0 4.426 3.573 8 8 8Zm-2.667-24c0-1.467 1.2-2.667 2.667-2.667 1.467 0 2.667 1.2 2.667 2.667v16C34.667 30.8 33.467 32 32 32a2.675 2.675 0 0 1-2.667-2.666v-16Zm16 16c0 7.36-5.973 13.333-13.333 13.333s-13.333-5.974-13.333-13.334h-5.334c0 9.414 6.96 17.147 16 18.454V56h5.334v-8.213c9.04-1.307 16-9.04 16-18.453h-5.334Z"
        />
      </g>
      <defs>
        <clipPath id="MicActiveIconUrl">
          <path fill="#fff" d="M0 0h64v64H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
